import { Component } from "react";
import { connect } from "react-redux";
/** @jsx jsx */
import { jsx } from "@emotion/react";
import Form from "./Form/";
import { default as mainMenuActionCreators } from "../../../store/MainMenu/actionCreators";
import actionCreators from "../../../store/Settings/SchoolYears/actionCreators";
import SettingsSchoolYearValues from "../../../fixtures/SettingsSchoolYear";
import formsCss from "../../../common/styles/forms.css";
import CurrentFormTypes from "../../../common/components/CurrentFormTypes";
import { Paper } from "@material-ui/core";
import globalsCss from "../../../common/styles/globals.css";

class NewSchoolYearsContainer extends Component {
    componentDidMount() {
        const { setTitle } = this.props;
        setTitle("Settings \u203A Academic Years");
    }

    componentWillUnmount() {
        const { clearTitle } = this.props;
        clearTitle();
    }

    onSubmit = values => {
        this.props.postSchoolYear(values);
    };

    render() {
        const {
            initialValues,
            history: { push },
            errorRes: { error, errors },
        } = this.props;
        const { onSubmit } = this;
        const currentFormType = CurrentFormTypes.NEW;

        return (
            <div>
                <Paper elevation={1}>
                    <div css={globalsCss.inner}>
                        <h2 css={globalsCss.subtitleTitle}>Add New Academic Year</h2>
                        {error && <div css={formsCss.genericError}>{error}</div>}
                        <Form
                            {...{
                                initialValues,
                                currentFormType,
                                onSubmit,
                                push,
                                errors,
                            }}
                        />
                    </div>
                </Paper>
            </div>
        );
    }
}

const dispatchToProps = {
    setTitle: mainMenuActionCreators.setTitle.create,
    clearTitle: mainMenuActionCreators.clearTitle.create,
    postSchoolYear: actionCreators.postSchoolYear.create,
};
const mapStateToProps = ({ SettingsSchoolYears }) => ({
    initialValues: SettingsSchoolYearValues,
    errorRes: SettingsSchoolYears.errorRes,
});
export default connect(mapStateToProps, dispatchToProps)(NewSchoolYearsContainer);
